export class SoundOptions {
    context: AudioContext;
}

export class Sound {
    public readonly buffer: AudioBuffer;
    public readonly context: AudioContext;

    constructor(options: SoundOptions) {
        this.context = options.context;
    }

    public async load(url: string): Promise<Sound> {
        (this as Mutable<Sound>).buffer = await e5.load("audiobuffer", url, {
            audioContext: this.context
        });
        return this;
    }
}